import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../Image/Image';
import SingleReview from '../SingleReview/SingleReview';

const Home = () => {
    const navigate = useNavigate();
    const handleSeeMore = () => {
        const path = `/reviews`;
        navigate(path);
    }
    return (
        <div className='positio-relative'>
            <Image></Image>
            <div className="container text-center mt-3 mb-4 p-2">
                <h2 className='fw-normal'>Your Favourite Life Changing Skincare MakeUp Products.</h2>
                <p className='mt-3 w-50 m-auto'>Number one Cosmetic Brand that gives you the touch of healthy glowing skin. We will assure you to provide 100% authentic products. Don't wait.. choose your favourite products and get 20% off.</p>
                <button className='btn btn-large bg-dark text-light px-4 py-2 m-3'>Shop Now</button>
            </div>
            <div className='text-center'>
                <h3 className='container fw-normal mt-5 text-center'>Customer Reviews:</h3>
                <SingleReview></SingleReview>
                <button onClick={handleSeeMore} className='btn btn-large py-0 px-5 mt-3 mb-5 bg-dark text-light'><small>See All Reviews</small></button>
            </div>
        </div>
    );
};

export default Home;